import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { PageContext } from '@axiom/ui';

import DetailLayout from '../layouts/detail';
import { TalentProfile } from '../components/TalentProfile/TalentProfile';

/**
 * @param {{ name?: string }} props
 */
export const TalentDetailPage = ({ name } = {}) => {
  const { id } = useParams();
  const { setTitle } = useContext(PageContext);
  setTitle('Talent Details');

  return (
    <DetailLayout wide>
      <TalentProfile expanded isDetail candidateId={id} />
    </DetailLayout>
  );
};

TalentDetailPage.propTypes = {
  name: PropTypes.string,
};
